import axios from "axios";
import { getDomainName } from "./helper";

export const uploadImage = (file, progressHandler) => {
  if (process.env.NODE_ENV === "production") {
    const url = "https://e.colorme.vn/web-api/v1/upload-image-public";
    const formData = new FormData();

    formData.append("image", file, file.name);

    return axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler,
    });
  } else {
    return new Promise(async (resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            link: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1669117676fy3DMHc6Ifepr2D.jpg",
          },
          status: 200,
        });
      }, 2000);
    });
  }
};

export const uploadVideo = (file, progressHandler) => {
  if (process.env.NODE_ENV === "production") {
    const url = `${window.location.protocol}//${getDomainName()}/api/auth-web/lesson/upload-video`;

    const formData = new FormData();
    formData.append("video", file);

    if (window.socket) {
      formData.append("socket_id", window.socket.id);
    }

    return axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressHandler,
    });
  } else {
    return new Promise(async (resolve) => {
      setTimeout(() => {
        resolve({
          data: { message: { uri: "/videos/mock-video-url" }, status: 200 },
          status: 0,
        });
      }, 5000);
    });
  }
};
